<template>
    <div class="card-container">
        <button @click="fecharProcessoDetalhado" class="close-button">
            <v-icon color="black">mdi-close</v-icon>
        </button>
        <div class="titulo_linha_do_tempo mb-8">
            {{ titulo }}
        </div>
        <div class="timeline">
            <div v-for="(step, index) in steps" :key="index" class="step">
                <div
                        :class="['circle', { active: step.text === ativo }]"
                        :style="{ backgroundColor: step.text === ativo ? step.color : 'grey' }"
                >
                    <v-icon color="white">{{ step.icon }}</v-icon>
                </div>
                <div class="step-text" :style="{ color: getColor(step) }">
                    {{ step.text }}
                </div>
                <div v-if="index < steps.length - 1" class="line"></div>
            </div>
        </div>

        <!-- Card Informativo para o passo ativo -->
        <div v-if="activeStep" class="info-card" :style="{ backgroundColor: activeStep.color }">
            <div class="info-card-content">
                <div class="info-title mb-2">
                    <v-icon class="info-icon" color="black">{{ activeStep.icon }}</v-icon>
                    {{ activeStep.text }}
                </div>
                <div class="info-message">{{ activeStep.message }}</div>
            </div>
        </div>
    </div>
</template>

<script>
  import { ListaAgrupamentosDeStatusContrato, ListaAgrupamentosDeStatusPedido, StatusAnaliseCadastral, ListaAgrupamentosDeStatusPagamento } from '../../../plugins/constants'
  import { colorAlerta, colorEmProcesso, colorErro, colorNeutro, colorSucesso, iconAlocado, iconAssinado, iconBloqueado, iconEspera, iconEsperandoAssinar, iconFalha, iconFinalizado, iconLoading, iconPagamento, iconRascunho, iconPago, iconPendente } from '../../../plugins/listaEstilosPorStatusPorNomeExibicao'
  import { StatusAlocacoes, StatusAlocacoesDesc } from '../../../plugins/status_alocacoes'
  import { ProcessosDeVenda } from '../../../plugins/processosDeVenda'
  export default {
    props: {
      processo: {
        type: String,
        required: false
      },
      ativo: {
        type: String,
        required: false
      },
      numeroDaCota: {
        type: [String, Number],
        default: '-'
      }
    },
    data () {
      return {
        steps: [],
        titulo: '-',
        steppersPorStatusPedido: [
          { text: ListaAgrupamentosDeStatusPedido.Rascunho, message: 'Proposta em rascunho, prossiga para iniciar o processo de venda.', color: colorNeutro, icon: iconRascunho },
          { text: ListaAgrupamentosDeStatusPedido.AguardandoEnvio, message: 'Proposta em geração, aguarde alguns instantes.', color: colorEmProcesso, icon: iconLoading },
          { text: ListaAgrupamentosDeStatusPedido.Pagamento, message: 'Proposta pendente de pagamento.', color: colorAlerta, icon: iconPagamento },
          { text: ListaAgrupamentosDeStatusPedido.Bloqueado, message: 'Ops, sua proposta foi cancelada. Entre em contato com a Área de Suporte para maiores detalhes.', color: colorErro, icon: iconBloqueado, hidden: true },
          { text: ListaAgrupamentosDeStatusPedido.Falha, message: 'Ops, falha na geração da sua proposta, entre em contato com a Área de Suporte.', color: colorErro, icon: iconFalha, hidden: true },
          { text: ListaAgrupamentosDeStatusPedido.Finalizado, message: 'Parabéns! Proposta finalizada com sucesso!', color: colorSucesso, icon: iconFinalizado }
        ],
        steppersPorStatusContrato: [
          { text: ListaAgrupamentosDeStatusContrato.EmEspera, message: 'Contrato ainda não gerado, finalize a proposta para geração automática. Seu cliente receberá o contrato no e-mail.', color: colorNeutro, icon: iconEspera },
          { text: ListaAgrupamentosDeStatusContrato.Falha, message: 'Ops, falha na geração do contrato, entre em contato com a Área de Suporte.', color: colorErro, icon: iconFalha, hidden: true },
          { text: ListaAgrupamentosDeStatusContrato.Pendente, message: 'Contrato pendente de assinatura por parte do cliente.', color: colorAlerta, icon: iconEsperandoAssinar },
          { text: ListaAgrupamentosDeStatusContrato.Negado, message: 'Contrato negado por parte do cliente.', color: colorErro, icon: iconBloqueado, hidden: true },
          { text: ListaAgrupamentosDeStatusContrato.Assinado, message: 'Contrato assinado por parte do cliente. Acompanhe o processo de alocação para maiores detalhes', color: colorSucesso, icon: iconAssinado }
        ],
        steppersPorStatusAnaliseCadastral: [
          { text: StatusAnaliseCadastral.Pendente, message: 'Proposta ainda não passou pela etapa de crédito.', color: colorNeutro, icon: iconEspera },
          { text: StatusAnaliseCadastral.PendenciaCadastral, message: 'Proposta pendente de alterações cadastrais. Clique em “Detalhes” para realizar o ajuste.', color: colorEmProcesso, icon: iconPendente },
          { text: StatusAnaliseCadastral.EmAnalise, message: 'Aguardando validação de dados. Clique em Detalhes para verificar se a validação foi concluída.', color: colorAlerta, icon: iconLoading },
          { text: StatusAnaliseCadastral.Reprovado, message: 'Venda cancelada na etapa de validação.', color: colorErro, icon: iconBloqueado, hidden: true },
          { text: StatusAnaliseCadastral.Aprovado, message: 'Proposta aprovada! Clique em Detalhes para prosseguir com sua proposta.', color: colorSucesso, icon: iconFinalizado }
        ],
        steppersPorStatusAlocacao: [
          { text: StatusAlocacoesDesc[StatusAlocacoes.NaoAlocado], message: 'Cota não alocada, obtenha a assinatura do contrato para alocação.', color: colorAlerta, icon: iconLoading },
          { text: StatusAlocacoesDesc[StatusAlocacoes.FalhaAlocacao], message: 'Ops, foi encontrado uma falha na alocação da cota, entre em contato com a Área de Suporte.', color: colorErro, icon: iconFalha, hidden: true },
          { text: StatusAlocacoesDesc[StatusAlocacoes.Cancelada], message: `Cota ${this.numeroDaCota} cancelada.`, color: colorErro, icon: iconBloqueado, hidden: true },
          { text: StatusAlocacoesDesc[StatusAlocacoes.Alocado], message: `Cota ${this.numeroDaCota} alocada!`, color: colorSucesso, icon: iconAlocado }
        ],
        steppersPorStatusPagamento: [
          { text: ListaAgrupamentosDeStatusPagamento.EmEspera, message: 'Proposta em rascunho, aguarde a finalização para prosseguir com o pagamento.', color: colorNeutro, icon: iconEspera },
          { text: ListaAgrupamentosDeStatusPagamento.Falha, message: 'Ops, foi obtido um erro no pagamento, por favor, entre em contato com a Área de Suporte indicando o seguinte erro: Ocorreu um erro ao gerar o boleto!', color: colorErro, icon: iconFalha, hidden: true },
          { text: ListaAgrupamentosDeStatusPagamento.Pendente, message: 'Proposta pendente de pagamento por parte do cliente.', color: colorEmProcesso, icon: iconLoading },
          { text: ListaAgrupamentosDeStatusPagamento.Realizado, message: 'Pagamento realizado com sucesso por parte do cliente!', color: colorSucesso, icon: iconPago }
        ]
      }
    },
    computed: {
      activeStep () {
        return this.steps.find(step => step.text === this.ativo)
      }
    },
    watch: {
      processo () {
        this.defineEtapa()
      }
    },
    mounted () {
      this.defineEtapa()
    },
    methods: {
      defineEtapa () {
        if (this.processo === ProcessosDeVenda.statusPedido) {
          this.steps = this.steppersPorStatusPedido
          this.titulo = ProcessosDeVenda.statusPedido
        } else if (this.processo === ProcessosDeVenda.statusAlocacao) {
          this.steps = this.steppersPorStatusAlocacao
          this.titulo = ProcessosDeVenda.statusAlocacao
        } else if (this.processo === ProcessosDeVenda.statusContrato) {
          this.steps = this.steppersPorStatusContrato
          this.titulo = ProcessosDeVenda.statusContrato
        } else if (this.processo === ProcessosDeVenda.statusCredito) {
          this.steps = this.steppersPorStatusAnaliseCadastral
          this.titulo = ProcessosDeVenda.statusCredito
        } else if (this.processo === ProcessosDeVenda.statusPagamento) {
          this.steps = this.steppersPorStatusPagamento
          this.titulo = ProcessosDeVenda.statusPagamento
        } else {
          this.titulo = 'Desculpe, ocorreu um erro ao carregar o processo selecionado.'
          this.steps = []
        }

        this.steps = this.filtrarSteps(this.steps)
      },
      filtrarSteps (steps) {
        const hiddenActiveSteps = steps.filter(step => step.hidden && step.text === this.ativo)
        if (hiddenActiveSteps.length > 0) {
          return steps.filter(step => !step.hiddenIfHiddenActive && (!step.hidden || step.text === this.ativo))
        } else {
          return steps.filter(step => !step.hidden || step.text === this.ativo)
        }
      },
      getColor (step) {
        return step.text === this.ativo ? step.color : 'var(--neutral)'
      },
      fecharProcessoDetalhado () {
        this.$emit('fecharProcessoDetalhado')
      }
    }
  }
</script>

<style scoped>
.card-container {
    width: 100%;
    position: relative;
    height: 100%;
    margin: 0 auto;
    padding: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #fff;
}

.titulo_linha_do_tempo {
    font-size: 1.5em;
    font-weight: bold;
    text-align: left;
    margin-bottom: 20px;
}

.timeline {
    max-width: calc(100vw - 160px);
    display: flex;
    overflow: scroll;
    align-items: start;
    position: relative;
}

.step {
    position: relative;
    flex: 1;
    text-align: center;
    min-width: 100px;
    margin-bottom: 10px;
}

.circle {
    width: 40px; /* Ajustar tamanho para telas menores */
    height: 40px; /* Ajustar tamanho para telas menores */
    border-radius: 50%;
    background-color: grey;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    margin: 0 auto;
    z-index: 1;
    position: relative;
}

.circle.active {
    background-color: inherit; /* Use color from inline style */
}

.step-text {
    margin-top: 10px;
    font-size: 1rem; /* Ajustar tamanho do texto */
    font-weight: 600;
}

.line {
    position: absolute;
    top: 20px; /* Ajustar para alinhar com o centro dos círculos */
    left: 50%;
    width: calc(100% - 40px); /* Ajusta a linha para não ultrapassar os círculos */
    height: 1px;
    background-color: grey;
    z-index: 0;
    transform: translateX(20px); /* Compensar metade da largura do círculo */
}

/* Estilos para o card informativo */
.info-card {
    width: 100%; /* Cobrir 100% da largura */
    border-radius: 10px;
    margin-top: 20px;
    padding: 8px 16px;
    color: black; /* Texto em preto */
}

.info-card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.info-title {
    display: flex; /* Flex para alinhar ícone e texto na mesma linha */
    align-items: center; /* Centraliza verticalmente */
    font-size: 1.5em; /* Tamanho do título */
    font-weight: bold;
    margin-top: 8px; /* Espaçamento superior */
}

.info-icon {
    font-size: 1.5em; /* Tamanho do ícone menor */
    margin-right: 8px; /* Espaçamento entre ícone e texto */
}

.info-message {
    font-size: 1.12rem; /* Tamanho da mensagem */
    margin-top: 4px; /* Espaçamento superior */
}

@media (max-width: 768px) {
    .titulo_linha_do_tempo {
        font-size: 1.25em; /* Reduzir tamanho do título para telas menores */
    }

    .circle {
        width: 30px; /* Reduzir tamanho dos círculos para telas menores */
        height: 30px;
    }

    .step-text {
        font-size: 0.875rem; /* Reduzir tamanho do texto para telas menores */
    }

    .line {
        top: 15px; /* Ajustar posição para alinhar com o centro dos círculos menores */
    }

    .info-title {
        font-size: 1.2em; /* Tamanho da fonte menor em dispositivos móveis */
    }

    .info-icon {
        font-size: 1.2em; /* Tamanho do ícone menor em dispositivos móveis */
    }
}
.close-button {
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 16px; /* Ajuste conforme necessário */
    right: 16px; /* Ajuste conforme necessário */
    z-index: 2; /* Para garantir que fique acima de outros elementos */
}

.close-button:hover {
    opacity: 0.7; /* Para dar um feedback visual ao passar o mouse */
}
</style>
